import type {
  QuotePdfSignedUrlResponseDto,
  QuotePdfVersionResponseDto,
} from '@trellis/api'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export const generateQuotePdf = (quoteId: string) =>
  request<QuotePdfVersionResponseDto>(() =>
    apiClient.api.quotePdfControllerGeneratePdf({ quoteId }),
  )

export const listQuotePdfVersions = (quoteId: string) =>
  request<QuotePdfVersionResponseDto[]>(() =>
    apiClient.api.quotePdfControllerListVersions({ quoteId }),
  )

export const getQuotePdfVersionSignedUrl = (quoteId: string, versionId: string) =>
  request<QuotePdfSignedUrlResponseDto>(() =>
    apiClient.api.quotePdfControllerGetVersionSignedUrl({ quoteId, versionId }),
  )

export const getQuotePdfLatestSignedUrl = (quoteId: string) =>
  request<QuotePdfSignedUrlResponseDto>(() =>
    apiClient.api.quotePdfControllerGetLatestSignedUrl({ quoteId }),
  )
